import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storage } from '@/configs/storage';
import type { Sender } from '@/features/sender-selection/types/sender';
import { SenderType } from '@/features/sender-selection/types/sender';
import { LAST_SENDER_STORE_KEY } from '@/shared/constants/store';

const DEFAULT_SENDER: Sender = { type: SenderType.USER };

type LastSenderStore = {
  sender: Sender;
  setSender: (sender: Sender) => void;
};

/**
 * Persists the last sender picked in the composer (post/comment) so the chip
 * remembers "post as org X" across app sessions. Source of truth for
 * the sender chip; the editor screen reads and writes it directly.
 */
export const useLastSenderStore = create<LastSenderStore>()(
  persist(
    (set) => ({
      sender: DEFAULT_SENDER,
      setSender: (sender) => set({ sender })
    }),
    {
      name: LAST_SENDER_STORE_KEY,
      storage: createJSONStorage(() => storage)
    }
  )
);
